import React from "react";

/** Naira-prefixed money input used across lease forms. */
export default function MoneyField({ label, value, onChange, testid, hint }) {
  return (
    <label className="block">
      <span className="text-xs font-bold uppercase tracking-wider text-[#5E7166]">{label}</span>
      <div className="relative mt-1">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5E7166] text-sm pointer-events-none">₦</span>
        <input
          type="number"
          min={0}
          step="any"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="input-modav pl-7"
          data-testid={testid}
        />
      </div>
      {hint && <span className="text-[10px] text-[#5E7166] italic mt-0.5 block">{hint}</span>}
    </label>
  );
}
